import { useContext } from 'react';
import { LanguageContext } from '@/context/LanguageContext';

/**
 * Translated label for low-level UI primitives (dialog close button, breadcrumb landmark) that
 * may render without a `LanguageProvider` (isolated tests): falls back to `fallback` then.
 */
export function useLabel(key: string, fallback: string): string {
  const context = useContext(LanguageContext);
  return context ? context.t(key) : fallback;
}
